module.exports = "<div class=\"profile-logo\"><p class=\"logo-text\">YouGiver</p></div>";